import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LocalCacheManager } from '../../api/managers/local-cache.manager';

@Injectable({
    providedIn: 'root'
})
export class MobileDeviceService
{
    private readonly HEADER_HEIGHT_MOBILE = 47;
    private readonly FOOTER_HEIGHT_MOBILE = 97;

    private readonly HEADER_HEIGHT_IPAD = 55;
    private readonly HEADER_HEIGHT_IPAD_W_WHATS_NEW = 77;
    private readonly FOOTER_HEIGHT_IPAD = 106;

    private readonly HEADER_HEIGHT_IPAD_PRO = 57;
    private readonly HEADER_HEIGHT_IPAD_PRO_W_WHATS_NEW = 77;
    private readonly FOOTER_HEIGHT_IPAD_PRO = 63;

    constructor(private deviceDetector: DeviceDetectorService,
                private localStorageManager: LocalCacheManager)
    { }

    get isMobile(): boolean
    {
        return this.deviceDetector.isMobile();
    }

    get isTablet(): boolean
    {
        return this.deviceDetector.isTablet();
    }

    get isMediumWidth(): boolean
    {
        return innerWidth >= 768 && innerWidth < 992;
    }

    get isSmallWdith(): boolean
    {
        return innerWidth >= 576 && innerWidth < 768;
    }

    get mainContainerHeight(): number
    {
        const innerWidth = window.innerWidth;
        const innerHeight = window.innerHeight;

        if (this.isMobile)
        {
            return innerHeight - this.HEADER_HEIGHT_MOBILE - this.FOOTER_HEIGHT_MOBILE;
        }

        if (this.isTablet)
        {
            if (innerWidth >= 1024)
            {
                return innerHeight - this.HEADER_HEIGHT_IPAD_PRO - (this.localStorageManager.doNotShowWhatsNew ? this.FOOTER_HEIGHT_IPAD_PRO : this.HEADER_HEIGHT_IPAD_PRO_W_WHATS_NEW);
            }

            if (innerWidth >= 768)
            {
                return innerHeight - this.HEADER_HEIGHT_IPAD - (this.localStorageManager.doNotShowWhatsNew ? this.FOOTER_HEIGHT_IPAD : this.HEADER_HEIGHT_IPAD_W_WHATS_NEW);
            }
        }
    }
}
